<template>
  <div>
    <div class="sign-up-title text-center mb-2">
      Contact
    </div>
    <div class="sign-up-subtitle text-center mb-5">Tell your team members how you like to communicate and be reached</div>
    <contact-form :submitting="submitting" submit-text="Finish" @back="$emit('back')" @skip="$emit('skip')" @submit="onSubmit" />
  </div>
</template>

<script>
import ContactForm from '@/components/forms/CreateProfile/ContactForm.vue'

export default {
  name: 'Contact',

  props: {
    submitting: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onSkip() {
      this.$store.dispatch('signup/clearContact')
        .then(() => this.$emit('skip'))
    },

    onSubmit(data) {
      this.$store.dispatch('signup/createContact', data)
        .then(() => this.$emit('submitted'))
    }
  },

  components: {
    ContactForm
  }
}
</script>
